module.exports = __webpack_public_path__ + "static/why-it-matters-687321f60b0e6b13c255f5056c775ef1.jpg";